import { render, staticRenderFns } from "./page-alerts.vue?vue&type=template&id=e036da12&"
import script from "./page-alerts.vue?vue&type=script&lang=js&"
export * from "./page-alerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports